import Swiper from 'swiper';


// Swiper set IDs
export function setIdForAllSwipers() {
    console.log('Swiper     IDs set for all swipers - function called');
    const swiperContainers = document.querySelectorAll('.swiper');

    if (swiperContainers) {
        swiperContainers.forEach(function (swiperContainer) {
            const uniqueId = Math.random().toString(36).substring(7);
            swiperContainer.parentElement.setAttribute('data-swiperid', uniqueId);
        });
    }
}

// init swiper under px threshold
export function initiateSwiperOnThreshold(swiperContainer, threshold, windowWidth, swiperArgs) {
    const existingSwiper = swiperContainer.swiper;

    if (windowWidth >= threshold) {
        if (existingSwiper) {
            existingSwiper.destroy();
        }
    } else if (!existingSwiper) {
        new Swiper(swiperContainer, swiperArgs);
    }
}

export function initiateSwiperOnThresholdInverted(swiperContainer, threshold, windowWidth, swiperArgs) {
    const existingSwiper = swiperContainer.swiper;

    if (windowWidth <= threshold) {
        if (existingSwiper) {
            existingSwiper.destroy();
        }
    } else if (!existingSwiper) {
        new Swiper(swiperContainer, swiperArgs);
    }
}